<template>
    <div class="modal is-active"  >
        <div class="modal-background"></div>
        <div class="modal-card">
            <header class="modal-card-head">
                <p class="modal-card-title">Confirm to delete?</p>

                <button class="delete" aria-label="close"   @click="closeBtn" ></button>
            </header>

            <section class="modal-card-body">
                <b-field label="Select Delete Reason"
                         :type="{ 'is-danger': hasErrorDoNotSelectReason}"
                         :message="{ 'pls select reason ': hasErrorDoNotSelectReason}">
                    <b-select placeholder="Select a reason"
                              v-model="deleteReasonsSelected"
                               >
                        <option
                                v-for="deleteReasons in deleteReasons"
                                :value="deleteReasons.id"
                                :key="deleteReasons.id">
                            {{ deleteReasons.name }}
                        </option>
                    </b-select>
                </b-field>


            </section>
            <footer class="modal-card-foot">
                <!--                <button class="button is-danger"   @click="closeBtn" >Cancel</button>-->
                <b-button type="is-danger"
                          icon-right="close"
                          @click="closeBtn" >Cancel</b-button>
                &nbsp;&nbsp;&nbsp;
                <b-button type="is-success"
                          icon-right="cloud-upload"
                          @click="saveData" >Save</b-button>

            </footer>
        </div>
    </div>


</template>

<script>
    import { getBaseURLforBackEnd , getConfigAxios}  from '@/utils.js'
    import axios from "axios"
    import { mapState } from "vuex";

    export default {
        name: "ConfirmToDeleteOrder",
        computed:{
            ...mapState({
                access_token: state => state.master_data.access_token,
            })
        },
        props:{
            dataToChild : null ,
            isConfirmToDeleteOrder : Boolean
        },
        data(){
            return {
                deleteReasons: [],
                deleteReasonsSelected : null,
                hasErrorDoNotSelectReason : true
            }
        },
        watch:{
            deleteReasonsSelected: function (val) {
                if(val !== null) {
                    this.hasErrorDoNotSelectReason = false
                }
            },
            isConfirmToDeleteOrder :{
                immediate: true,
                handler: function (val) {
                    if(val) {
                        this.loadDeleteReason()
                    }
                }
            }
        },
        methods:{
            saveData(){

                this.deleteReasonsSelected!== null ?  this.hasErrorDoNotSelectReason = false :  this.hasErrorDoNotSelectReason = true

                if(!this.hasErrorDoNotSelectReason){
                    // console.log('ok to save')
                    //
                    const datTo =   {
                        "id" : this.dataToChild,
                        "id_reason" : this.deleteReasonsSelected
                    }
                    const  vm = this
                    axios.defaults.headers.common['Authorization'] = `Bearer ${this.access_token}`
                    axios.post(`${getBaseURLforBackEnd()}/api/deleteorderlab_byid`,datTo,getConfigAxios())
                        .then(()=>{
                            vm.closeBtn()
                        })
                        .catch(err=>{
                            vm.$buefy.dialog.alert({
                                title: 'Error',
                                message: `Error  from ${err}`,
                                type: 'is-danger',
                                hasIcon: true,
                                icon: 'times-circle',
                                iconPack: 'fa',
                                ariaRole: 'alertdialog',
                                ariaModal: true
                            })
                            vm.closeBtn()
                        })
                }

            },
            closeBtn(){
                this.$emit('close')
            },
            loadDeleteReason(){
                            // clear err first popup
                            this.hasErrorDoNotSelectReason = false
                            // load data into select
                            const datTo =   {
                                "admin" : false
                            }
                            const  vm = this
                            axios.defaults.headers.common['Authorization'] = `Bearer ${this.access_token}`
                            axios.post(`${getBaseURLforBackEnd()}/api/listofdeleteorderreason`,datTo,getConfigAxios())
                                .then((res)=>{
                                    vm.deleteReasons = res.data
                                    })
                                .catch(err=>{
                                   console.log(err)
                                })
            }
        }
    }
</script>

<style scoped>

</style>